var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselMedical = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "7ck8hsqx5a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#7ck8hsqx5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.585 48.188 0 45.764l.097-25.036c.099-.38.292-.936.685-1.524a5.13 5.13 0 0 1 1.308-1.34L31.635.65l1.3-.65 3.272 1.966.864.522",
    fill: "#1C7792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.813 49.93-4.58-2.464.096-25.244c.1-.382.291-.937.68-1.525a5.109 5.109 0 0 1 1.296-1.338L34.402 2.277l1.275-.64 3.24 1.949",
    fill: "#8DBBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.344 32.637 8.794 49.811c-.897.522-1.632-.074-1.64-1.328l-.15-23.92c-.008-1.246.709-2.687 1.603-3.22L38.028 3.79c.924-.55 1.683.027 1.699 1.29L40 29.352c.013 1.274-.727 2.744-1.654 3.283l-.002.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C7792",
    transform: "rotate(-60.82 24.744 25.358)",
    cx: 24.744,
    cy: 25.358,
    rx: 11.584,
    ry: 6.814
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.068 24.341v-3.584l3.723-2.098.203-.11v3.32l3.035-1.656v4.576l-2.977 1.813v3.456l-3.988 2.488v-3.671l-3.087 1.757v-4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.04 3.118c-.061-.085-.508-.692-1.16-.647a1.06 1.06 0 0 0-.454.14l-8.7 5.658a2.53 2.53 0 0 0-.553 1.016c-.07.254-.09.483-.093.663l.031 4.063.895.5-.021-4.278",
    fill: "#146F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.622 3.677c-.06-.086-.498-.685-1.135-.642a1.05 1.05 0 0 0-.445.138l-8.519 5.606a2.5 2.5 0 0 0-.54 1.006c-.068.252-.09.48-.091.656l.03 4.024.876.494-.021-4.237",
    fill: "#77AEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77AEBB",
    d: "m25.053 4.86-.05 3.27.95.692.016-3.99M16.785 10.918l.52.63-.534 1.712"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#77AEBB",
    d: "m16.727 10.648.519.632-.533 1.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.662 14.343v-3.605a.909.909 0 0 1 .15-.621.686.686 0 0 1 .268-.221l7.281-4.62.25-.13c.134-.061.265-.028.318.063.029.05.027.108.023.145v3.468l.904-.526V3.999c-.054-.29-.242-.51-.47-.559a.543.543 0 0 0-.423.101L17.71 8.849a2.112 2.112 0 0 0-.686.81 2.446 2.446 0 0 0-.238 1.222l.01 3.937v.145",
    fill: "#E9F4F5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselMedical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-medical.0231455b20e6aaef831ad397ac0d5c77.svg";